<script setup>
import { pageTransition } from '~/helpers/animations/animations';
const route = useRoute();

definePageMeta({
  pageTransition: pageTransition,
});

const { t } = useI18n();
const breadcrumbs = ref([{ title: t('pages.events.breadcrumbs-title') }]);

const pageQuery = gql`
  query getPageData {
    buildings(filterVisibleInFilters: true) {
      id
      name
      seo_url_slug {
        cs
        en
      }
    }
    tags(filterVisibleInFilters: true) {
      id
      name
      description
      slug {
        cs
        en
      }
    }
    eventCategories {
      id
      name
      slug {
        cs
        en
      }
    }
  }
`;

const { data } = await useAsyncQuery(pageQuery);

const buildings = computed(() => data.value?.buildings ?? []);
const tags = computed(() => data.value?.tags ?? []);
const eventCategories = computed(() => data.value?.eventCategories ?? []);

useHeadData({
  title: t('pages.events.breadcrumbs-title'),
  description: t('pages.events.head.description'),
  keywords: t('pages.events.head.keywords'),
  image: null,
  url: route.fullPath,
});
</script>

<template>
  <main class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <div v-if="buildings && tags && eventCategories">
      <Events :buildings="buildings" :tags="tags" :event-categories="eventCategories" />
    </div>
  </main>
</template>
